module.exports = __webpack_public_path__ + "static/media/old-tv1.110c2fd8.jpg";